<template>
    <div id="content-basicas">
        <div class="section-basicas" v-for="item in data">
            <div class="section-text">
                <h1 class="my-0">{{ item.title }}</h1>
                <span>
                    {{ item.description }}
                </span>
            </div>
            <div class="section-products">
                <template v-if="item.type === 'basicas'">
                    <div class="product-grid main">
                        <div
                            v-for="(item, index) in basicProducts"
                            v-if="index < 2"
                            class="product-item"
                        >
                            <a
                                :href="$scope.URL + item.product.data.link_rewrite_full"
                                target="_blank"
                            >
                                <picture>
                                    <source
                                        :srcset="`${$scope.CDN_IMAGES}/images/site/colecoes-basicas/imgs/${item.desktop_image}?auto=compress,format&q=65`"
                                        media="(min-width: 576px)"
                                    />
                                    <img
                                        :src="`${$scope.CDN_IMAGES}/images/site/colecoes-basicas/imgs/${item.mobile_image}?auto=compress,format&q=65`"
                                        :alt="item.product.data.name"
                                        class="item-img"
                                    />
                                </picture>
                                <div class="item-hover">
                                    <span class="text-uppercase">{{ item.product.data.name }}</span>
                                    <span class="hover-price">
                                        por
                                        <span class="text-uppercase">{{
                                            item.product.data.price
                                        }}</span>
                                    </span>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="product-grid secondary">
                        <div
                            v-for="(item, index) in basicProducts"
                            v-if="index >= 2"
                            class="product-item"
                        >
                            <a
                                :href="$scope.URL + item.product.data.link_rewrite_full"
                                target="_blank"
                            >
                                <picture>
                                    <source
                                        :srcset="`${$scope.CDN_IMAGES}/images/site/colecoes-basicas/imgs/${item.desktop_image}?auto=compress,format&q=65`"
                                        media="(min-width: 576px)"
                                    />
                                    <img
                                        :src="`${$scope.CDN_IMAGES}/images/site/colecoes-basicas/imgs/${item.mobile_image}?auto=compress,format&q=65`"
                                        :alt="item.product.data.name"
                                        class="item-img"
                                    />
                                </picture>
                                <div class="item-hover">
                                    <span class="text-uppercase">{{ item.product.data.name }}</span>
                                    <span class="hover-price">
                                        por
                                        <span class="text-uppercase">{{
                                            item.product.data.price
                                        }}</span>
                                    </span>
                                </div>
                            </a>
                        </div>
                    </div>
                    <a :href="item.categoryUrl" target="_blank">
                        <div class="section-button">Ver todas as cores</div>
                    </a>
                </template>

                <template v-else-if="item.type === 'estacao'">
                    <a
                        class="banner-pima"
                        href="/camiseta/camiseta-basica-verde-maca-171519.html"
                        target="_blank"
                    >
                        <picture>
                            <source
                                :srcset="`${$scope.CDN_IMAGES}/images/site/colecoes-basicas/imgs/banner_home_desktop_verdemaca_151024.png?auto=compress,format&q=65`"
                                media="(min-width: 576px)"
                            />
                            <img
                                :src="`${$scope.CDN_IMAGES}/images/site/colecoes-basicas/imgs/banner_home_mobile_verdemaca_151024.png?auto=compress,format&q=65`"
                                alt="Cor da estação"
                                class="img-responsive center-block"
                            />
                        </picture>
                    </a>
                </template>

                <template v-else-if="item.type === 'pima'">
                    <a class="banner-pima" :href="item.categoryUrl" target="_blank">
                        <picture v-if="pimaBanner.desktop_image && pimaBanner.mobile_image">
                            <source
                                :srcset="`${$scope.CDN_IMAGES}/images/site/colecoes-basicas/imgs/${pimaBanner.desktop_image}?auto=compress,format&q=65`"
                                media="(min-width: 576px)"
                            />
                            <img
                                :src="`${$scope.CDN_IMAGES}/images/site/colecoes-basicas/imgs/${pimaBanner.mobile_image}?auto=compress,format&q=65`"
                                alt="Banner Pima"
                                class="img-responsive center-block"
                            />
                        </picture>
                    </a>
                </template>

                <template v-else-if="item.type === 'outros-produtos'">
                    <div class="product-grid other-products">
                        <div
                            v-for="(product, index) in otherProducts"
                            class="product-item"
                            :class="`item-${index + 1}`"
                        >
                            <a :href="item.content[index].productUrl" target="_blank">
                                <picture>
                                    <source
                                        :srcset="`${$scope.CDN_IMAGES}/images/site/colecoes-basicas/imgs/${product.desktop_image}?auto=compress,format&q=65`"
                                        media="(min-width: 768px)"
                                    />
                                    <img
                                        :src="`${$scope.CDN_IMAGES}/images/site/colecoes-basicas/imgs/${product.mobile_image}?auto=compress,format&q=65`"
                                        :alt="product.product.data.name"
                                        class="item-img"
                                    />
                                </picture>

                                <div class="item-hover">
                                    <span class="text-uppercase text-center">{{
                                        item.content[index].title
                                    }}</span>
                                </div>
                            </a>
                        </div>
                    </div>
                </template>

                <template v-else-if="item.type === 'kit-basicas'">
                    <div class="product-grid secondary">
                        <div
                            v-for="(product, index) in kitBasicsProducts"
                            class="product-item"
                            :class="`item-${index + 1}`"
                        >
                            <a
                                :href="$scope.URL + product.product.data.link_rewrite_full"
                                target="_blank"
                            >
                                <picture>
                                    <source
                                        :srcset="`${$scope.CDN_IMAGES}/images/site/colecoes-basicas/imgs/${product.desktop_image}?auto=compress,format&q=65`"
                                        media="(min-width: 768px)"
                                    />
                                    <img
                                        :src="`${$scope.CDN_IMAGES}/images/site/colecoes-basicas/imgs/${product.mobile_image}?auto=compress,format&q=65`"
                                        :alt="product.product.data.name"
                                        class="item-img"
                                    />
                                </picture>

                                <div class="item-hover">
                                    <span class="text-uppercase text-center">{{
                                        product.product.data.name
                                    }}</span>
                                </div>
                            </a>
                        </div>
                    </div>
                </template>

                <template v-else-if="item.type === 'bolso'">
                    <div class="product-grid secondary">
                        <div v-for="item in withPocketProducts" class="product-item">
                            <a
                                :href="$scope.URL + item.product.data.link_rewrite_full"
                                target="_blank"
                            >
                                <picture>
                                    <source
                                        :srcset="`${$scope.CDN_IMAGES}/images/site/colecoes-basicas/imgs/${item.desktop_image}?auto=compress,format&q=65`"
                                        media="(min-width: 576px)"
                                    />
                                    <img
                                        :src="`${$scope.CDN_IMAGES}/images/site/colecoes-basicas/imgs/${item.mobile_image}?auto=compress,format&q=65`"
                                        :alt="item.product.data.name"
                                        class="item-img"
                                    />
                                </picture>
                                <div class="item-hover">
                                    <span class="text-uppercase">{{ item.product.data.name }}</span>
                                    <span class="hover-price">
                                        por
                                        <span class="text-uppercase">{{
                                            item.product.data.price
                                        }}</span>
                                    </span>
                                </div>
                            </a>
                        </div>
                    </div>
                    <a :href="item.categoryUrl" target="_blank">
                        <div class="section-button">Ver todas as cores</div>
                    </a>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ContentBasicas',
        props: {
            data: {
                type: Array,
                required: true,
            },
            basicProducts: {
                type: Array,
                required: true,
            },
            pimaBanner: {
                type: Object,
                required: true,
            },
            withPocketProducts: {
                type: Array,
                required: true,
            },
            otherProducts: {
                type: Array,
                required: true,
            },
            kitBasicsProducts: {
                type: Array,
                required: true,
            },
        },

        // methods: {
        //     mountPhrase(frase) {
        //         let palavras = frase.split(' ');
        //         let primeiraPalavra = palavras[0];
        //         let palavraComS = primeiraPalavra + 'S';
        //         return 'Veja nossas ' + palavraComS;
        //     }
        // },
    };
</script>
